import { availableFeatures, supportedLanguages } from "./content.types";

export const eventDates = {
  event: {
    date: '2025-06-01T00:00:00',
    label: '01.06.2025',
  },
  preSale: {
    date: '2025-01-25T00:00:00',
    label: '10.01.2025',
  }
}

export const COPY = {
  [supportedLanguages.pt]: {
    loadingScreen: {
      disclaimer: "For a better experience<br />use headphones",
      cta: "ENTER",
    },
    landingScreen: {
      title: "NOVO NISSAN KICKS",
      titleMobile: "NOVO<br/>NISSAN KICKS",
      subtitle: "ATTITUDE TO DISRUPT",
      cta: "CLIQUE E ACOMPANHE A REVELAÇÃO",
      ctaMobile: "CLIQUE E ACOMPANHE A REVELAÇÃO",
      disclaimer: "Imagem meramente ilustrativa desenvolvida por computação gráfica. Alguns itens e aspectos do veículo podem apresentar variações em relação ao veículo real que será comercializado."
    },
    homeScreen: {
      title: "NOVO NISSAN KICKS",
      subtitle: "ATTITUDE TO DISRUPT",
      learnMoreCta: "QUERO RECEBER AS NOVIDADES",
      learnMoreCtaURL: "",
      promotionalCta: "Confira o lançamento​",
      interiorCta: "Ver<br/>interior",
      exteriorCta: "Ver<br/>exterior",
      eventCtaPre: "Evento de<br/>lançamento",
      eventCtaPreURL: "",
      eventCtaLive: "Confira o<br/>lançamento",
      eventCtaPos: "PRE-VENDA",
      joystickCta: "LEARN MORE",
    },
    gallery: {
      title: 'LOREM IPSUM',
      subtitle: 'Lorem ipsum dolor sit amet consectetur. Mauris arcu ultricies sagittis faucibus. Commodo penatibus.',
    },
    event: {
      title: 'LOREM IPSUM',
      subtitle: {
        left: 'LOREM IPSUM',
        right: 'Lorem ipsum dolor sit amet consectetur. mauris arcu ultricies sagittis faucibus. commodo penatibus.',
      },
      location: 'SÃO PAULO',
      date: eventDates.event.date,
      label: eventDates.event.label,
      eventDay: eventDates.event.date,
      time: {
        days: 'DIAS',
        hours: 'HORAS',
        minutes: 'MINUTOS',
        seconds: 'SEGUNDOS',
      },
      cta: 'QUERO MEUS INGRESSOS',
    },
    preSale: {
      title: 'LANÇAMENTO',
      subtitle: {
        left: 'FECHAR',
        right: 'Lorem ipsum dolor sit amet consectetur. mauris arcu ultricies sagittis faucibus. commodo penatibus.',
      },
      location: 'SÃO PAULO',
      date: eventDates.event.date,
      label: eventDates.event.label,
      eventDay: eventDates.event.date,
      time: {
        days: 'DIAS',
        hours: 'HORAS',
        minutes: 'MINUTOS',
        seconds: 'SEGUNDOS',
      },
      cta: 'IR PARA O SITE DE PRÉ-VENDA',
    },
    features: {
      [availableFeatures.somBose]: {
        title: 'Som Bose (speakers)',
        subtitle: '',
        description: 'Alto-falantes de alta definição: uma experiência sonora incomparável.',
      },
      [availableFeatures.assinaturaDeDesign]: {
        title: 'Assinatura de design',
        subtitle: '',
        description: 'Design que atrai olhares por onde passa.',
      },
      [availableFeatures.soleira]: {
        title: 'Soleira das portas',
        subtitle: '',
        description: 'Detalhes inspirados no dinamismo da atitude urbana.',
      },
      [availableFeatures.cambio]: {
        title: 'Câmbio E-Shifter',
        subtitle: '',
        description: 'Tecnologia e-Shifter: direção mais prática e confortável.',
      },
      [availableFeatures.coluna]: {
        title: 'Coluna',
        subtitle: '',
        description: 'Uma expressão de atitude em todos detalhes.',
      },
      [availableFeatures.retrovisor]: {
        title: 'Retrovisor',
        subtitle: '',
        description: 'Detalhes que redefinem o design.',
      },
      [availableFeatures.farolGrade]: {
        title: 'Farol e grade',
        subtitle: '',
        description: 'Redesenhado para impressionar: nova grade frontal robusta e faróis em LED.',
      },
      [availableFeatures.lanternaTraseira]: {
        title: 'Lanterna traseira',
        subtitle: '',
        description: 'Lanternas traseiras que revelam uma nova identidade, com estilo e sofisticação',
      },
      [availableFeatures.tetoSolar]: {
        title: 'Teto panorâmico/solar',
        subtitle: '',
        description: 'Teto solar panorâmico: explore seu caminho com liberdade e atitude.',
      },
      [availableFeatures.telas]: {
        title: 'Telas (TFT + Multimídia)',
        subtitle: '',
        description: 'Telas amplas: tecnologia, informação e entretenimento ao seu alcance.',
      },
      [availableFeatures.biTone]: {
        title: 'Cor Bi-tone',
        subtitle: '',
        description: 'A combinação bi-tone une elegância e dinamismo, destacando seu design moderno',
      },
      [availableFeatures.rodas]: {
        title: 'Rodas',
        subtitle: '',
        description: 'Rodas com design exclusivo: estilo e personalidade em cada movimento.',
      },
    }
  },
  [supportedLanguages.es]: {
    loadingScreen: {
      disclaimer: "Para una mejor experiencia,<br />utilice auriculares.",
      cta: "INGRESAR",
    },
    landingScreen: {
      title: "NUEVA NISSAN KICKS",
      titleMobile: "NUEVA<br/>NISSAN KICKS",
      subtitle: "ATTITUDE TO DISRUPT",
      cta: "HACÉ CLIC Y SEGUÍ LA REVELACIÓN",
      ctaMobile: "HACÉ CLIC Y SEGUÍ LA REVELACIÓN",
      disclaimer: "Imagen meramente ilustrativa desarrollada por computación gráfica. Algunos elementos y aspectos del vehículo pueden presentar variaciones con respecto al vehículo real que será comercializado."
    },
    homeScreen: {
      title: "NUEVA NISSAN KICKS",
      subtitle: "ATTITUDE TO DISRUPT",
      learnMoreCta: "QUIERO RECIBIR LAS NOVEDADES",
      learnMoreCtaURL: "",
      promotionalCta: "Conocé el lanzamiento",
      interiorCta: "Ver<br/>interior",
      exteriorCta: "Ver<br/>exterior",
      eventCtaPre: "Evento de<br/>lanzamiento",
      eventCtaPreURL: "",
      eventCtaLive: "Conocé el<br/>lanzamiento",
      eventCtaPos: "PRE-VENTA",
      joystickCta: "CONOCÉ MÁS",
    },
    gallery: {
      title: 'LOREM IPSUM',
      subtitle: ' dolor sit amet consectetur. Mauris arcu ultricies sagittis faucibus. Commodo penatibus.',
    },
    event: {
      title: 'LOREM IPSUM',
      subtitle: {
        left: 'LOREM IPSUM',
        right: 'Lorem ipsum dolor sit amet consectetur. mauris arcu ultricies sagittis faucibus. commodo penatibus.',
      },
      location: 'BUENOS AIRES',
      date: eventDates.event.date,
      label: eventDates.event.label,
      eventDay: eventDates.event.date,
      time: {
        days: 'DÍAS',
        hours: 'HORAS',
        minutes: 'MINUTOS',
        seconds: 'SEGUNDOS',
      },
      cta: 'QUIERO MIS ENTRADAS',
    },
    preSale: {
      title: 'LANZAMIENTO',
      subtitle: {
        left: 'LOREM IPSUM',
        right: 'Lorem ipsum dolor sit amet consectetur. mauris arcu ultricies sagittis faucibus. commodo penatibus.',
      },
      location: 'BUENOS AIRES',
      date: eventDates.event.date,
      label: eventDates.event.label,
      eventDay: eventDates.event.date,
      time: {
        days: 'DÍAS',
        hours: 'HORAS',
        minutes: 'MINUTOS',
        seconds: 'SEGUNDOS',
      },
      cta: 'IR AL SITIO DE PRE-VENTA',
    },
    features: {
      [availableFeatures.somBose]: {
        title: 'Sonido Bose (altavoces)',
        subtitle: '',
        description: 'Altavoces de alta definición: una experiencia de sonido inigualable.',
      },
      [availableFeatures.assinaturaDeDesign]: {
        title: 'Firma de diseño',
        subtitle: '',
        description: 'Líneas que capturan miradas a donde quiera que vayas.',
      },
      [availableFeatures.soleira]: {
        title: 'Umbral de las puertas',
        subtitle: '',
        description: 'Detalles inspirados en el dinamismo de la actitud urbana.',
      },
      [availableFeatures.cambio]: {
        title: 'Cambio E-Shifter',
        subtitle: '',
        description: 'Tecnología e-Shifter: conducción más práctica y cómoda.',
      },
      [availableFeatures.coluna]: {
        title: 'Columna',
        subtitle: '',
        description: 'Una expresión de actitud en todos los detalles.',
      },
      [availableFeatures.retrovisor]: {
        title: 'Retrovisor',
        subtitle: '',
        description: 'Detalles que redefinen el diseño.',
      },
      [availableFeatures.farolGrade]: {
        title: 'Faro y parrilla',
        subtitle: '',
        description: 'Rediseñado para impresionar: nueva parrilla delantera robusta y con faros LED.',
      },
      [availableFeatures.lanternaTraseira]: {
        title: 'Luces traseras',
        subtitle: '',
        description: 'Luces traseras que revelan una nueva identidad, con estilo y sofisticación.',
      },
      [availableFeatures.tetoSolar]: {
        title: 'Techo panorámico/solar',
        subtitle: '',
        description: 'Techo solar panorámico: Descubrí el entorno que te rodea.',
      },
      [availableFeatures.telas]: {
        title: 'Pantallas (TFT + Multimedia)',
        subtitle: '',
        description: 'Pantallas panorámicas: tecnología, información y entretenimiento al alcance de tu mano.',
      },
      [availableFeatures.biTone]: {
        title: 'Color Bi-tono',
        subtitle: '',
        description: 'La combinación bitono combina elegancia y dinamismo, destacando su diseño moderno.',
      },
      [availableFeatures.rodas]: {
        title: 'Ruedas',
        subtitle: '',
        description: 'Ruedas de diseño único: estilo y personalidad en cada movimiento.',
      },
    }
  },
};
